import styled from "styled-components";
import { hideScrollBar } from "../../../../../../commonStyles";
import {
  FlexColumn,
  FlexRow,
  FlexRowCenter,
} from "../../../../../Common/Styles";

export const CircleListContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-11"].value}rem;
  right: 20px;
  width: 290px;
`;

export const Container = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: linear-gradient(
    116deg,
    #f4fbff 21.57%,
    rgba(230, 236, 255, 0) 76.26%
  );
`;

export const ScrollContainer = styled(FlexColumn)`
  max-height: 224px;
  overflow-y: auto;
  ${hideScrollBar}
`;

export const EmptyCircleContainer = styled(FlexRowCenter)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
`;

export const ConfirmationContainer = styled(FlexRow)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const WarningCircle = styled(FlexRowCenter)`
  min-width: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-full-round"].value}rem;
  background: #fef0c7;

  svg {
    min-width: ${({ theme }) => theme.spacing["spacing-3"].value}rem !important;
    min-height: ${({ theme }) =>
      theme.spacing["spacing-3"].value}rem !important;
    width: ${({ theme }) => theme.spacing["spacing-3"].value}rem !important;
    height: ${({ theme }) => theme.spacing["spacing-3"].value}rem !important;
  }
`;
